import { dew as _stream_transformDew } from "./_stream_transform";
import * as _inherits2 from "inherits";
var _inherits = "default" in _inherits2 ? _inherits2.default : _inherits2;
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  exports = PassThrough;
  var Transform = _stream_transformDew();
  _inherits(PassThrough, Transform);
  function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);
    Transform.call(this, options);
  }
  PassThrough.prototype._transform = function (chunk, encoding, cb) {
    cb(null, chunk);
  };
  return exports;
}